import { SetDefaultData, FetchPaymentPurposeRequest, UpdateField, UpdatePaymentPurposeRequest } from './../payment-purposes.actions';
import { getUpdatePaymentPurposeState } from '../payment-purposes.selectors';
import Validator from '@shared/validatorjs/src/validator';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Subscription } from 'rxjs';
import { Map } from 'immutable';

@Component({
  selector: 'app-update-payment-purpose',
  templateUrl: './update-payment-purpose.component.html',
  styleUrls: ['./update-payment-purpose.component.css']
})
export class UpdatePaymentPurposeComponent extends FormTrait implements OnInit, OnDestroy {

  private state$: Subscription;
  public isLoading: boolean;
  public PaymentPurposeId: number;

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.PaymentPurposeId = parseInt(this.route.snapshot.paramMap.get("id"))
    this.store.dispatch<any>(new SetDefaultData('updatePaymentPurpose'))
    this.state$ = this.store.pipe(select(getUpdatePaymentPurposeState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });

    this.store.dispatch<any>(new FetchPaymentPurposeRequest(this.PaymentPurposeId))
  }

  ngOnDestroy(){
    this.state$.unsubscribe();
  }

  public handleFieldChange(e: any, name: null | string = null): void {

    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'updatePaymentPurpose.data')
    );

    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'updatePaymentPurpose')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required",
    };
    const validator = new Validator(
      data.toJS(),
      rules,
    );

    return validator;
  }

  public onSubmit(e: Event): void {

    e.preventDefault();

    const validation = this.validation();
    const payload = this.state.get('data').toJS();

    if (validation.passes()) {
      this.store.dispatch(new UpdatePaymentPurposeRequest(this.PaymentPurposeId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'updatePaymentPurpose')
      );
    }
  }

}
